module.exports = __webpack_public_path__ + "static/media/mn1.695be129.jpeg";